module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share"
  }, [_c('span', {
    staticClass: "share__label"
  }, [_vm._v("\n    Spread the word\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "share__list"
  }, [_c('social-sharing', {
    attrs: {
      "url": this.overviewUrl,
      "twitter-user": "ICIJorg",
      "title": "Explore: Welcome to Mauritius, Africa’s popular offshore tax hub. #ParadisePapers"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('span', {
            staticClass: "share__list__item"
          }, [_c('network', {
            staticClass: "share__list__item__link",
            attrs: {
              "network": "twitter"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("On Twitter")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-twitter",
            attrs: {
              "title": "Share on Twitter"
            }
          })])], 1)])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": this.overviewUrl,
      "title": "Explore: See how companies are slashing their taxes in Africa",
      "description": "Discover the tax agreements helping companies investing in Africa slash their tax bill."
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('span', {
            staticClass: "share__list__item"
          }, [_c('network', {
            staticClass: "share__list__item__link",
            attrs: {
              "network": "facebook"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("On Facebook")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-facebook",
            attrs: {
              "title": "Share on Facebook"
            }
          })])], 1), _vm._v(" "), _c('span', {
            staticClass: "share__list__item"
          }, [_c('network', {
            staticClass: "share__list__item__link",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("On Linkedin")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-linkedin",
            attrs: {
              "title": "Share on Linkedin"
            }
          })])], 1)])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "share__list__item"
  }, [_c('a', {
    staticClass: "share__list__item__link",
    attrs: {
      "tabindex": ""
    },
    on: {
      "click": _vm.showEmbed
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Embed")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-code",
    attrs: {
      "title": "Embed on your website"
    }
  })])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f22297a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Share.vue
// module id = 597
// module chunks = 1